<template>
  <div
    class="w-max max-w-full text-W4 text-[11px] leading-[13px] text-gray600 text-left p-2 rounded-[4px] bg-gray200"
    @click="$emit('click-tag')"
  >
    {{ `#${tagName}` }}
  </div>
</template>
<script>
const BaseTag = {
  name: 'BaseTag',
  props: {
    /** タグ名 */
    tagName: {
      type: String,
      required: true,
    },
  },
  emits: ['click-tag'],
}
export default BaseTag
</script>
<style scoped></style>
